module.exports = __webpack_public_path__ + "static/media/arrow.daa20df1.svg";